import React, { useState, useEffect, useContext } from "react";
import Select from "../wms/select";
import { getBranchList, getCurrentCar,getCarDetail } from "../../services/wms";
import Reporttable from "./rendertable";
import BranchContext from "../context/branch";
import Totalcar from "./totalcar";
import ProgressBar from './../common/progressbar';

import TruckDetail from "./../woodchip/modaltruckDetail";
const Reportwms = ({disabled}) => {
  const [branchlist, setbranchlist] = useState([]);
  const [headlist, setheadlist] = useState([]);
  const [totallist, settotallist] = useState([]);
  const [branchId, setbranchId] = useState(0);
  const [currentcar, setcurrentcar] = useState([]);
  const { currentBranch } = useContext(BranchContext);

  const [carDetials, setcarDetials] = useState([]);
  const [statusid, setstatusid] = useState(0);
  const [branchID, setbranchID] = useState(0);
  const [carID, setcarID] = useState(0);
  const [isOpen, setisOpen] = useState(false);
  const [showallsite, setshowallsite] = useState(false);

  

  const [showprogress, setshowprogress] = useState(false)
  const [completed, setcompleted] = useState(50)

  useEffect(() => {
    if (!currentBranch) return;
    const loadData = async () => {
      const { data: result } = await getBranchList();
      if (result.status === "success") {
        setbranchlist(result.data.list);
      }
    };
    loadData();
  }, [currentBranch]);

  useEffect(() => {
    if (!currentBranch) return;
    const loadData = async () => {

      setshowprogress(true)
      disabled(true)
      const { data: result } = await getCurrentCar(branchId);
      if (result.status === "success") {
        disabled(false)
        setshowprogress(false);
        setcurrentcar(result.data.list);
        setheadlist(result.data.header);
        settotallist(result.data.total);
      }
    };
    loadData();
  }, [currentBranch, branchId]);

  useEffect(() => {
    if (!currentBranch) return;

    // if (carID == 0) return;
    if (statusid == 0) return;
    // if (branchID == 0) return;

    const getdata = async () => {
      const { data: result } = await getCarDetail(branchID, statusid, carID);

      if (result.status === "success") {
        setcarDetials(result.data.list);
      }
    };
    getdata();
  }, [currentBranch, branchID, statusid, carID]);

const handelDetailClick =(event, branchid, statusid) =>{
  setbranchID(branchid);
  setstatusid(statusid);
  setcarID(event);
  setisOpen(true);
}
const handleClose = () => {
  setshowallsite(false)
  setisOpen(false);
};


  const handleBranchChange = (event) => {
    setbranchId(event.currentTarget.value);
  };
const handelClick =(event) =>{
  setbranchID(0);
  setcarID(0);
  setstatusid(event);
  setshowallsite(true)
  setisOpen(true);

}
  
  return (
    <>
     <TruckDetail
        isOpen={isOpen}
        onCancel={handleClose}
        message="ข้อมูลรถ"
        list={carDetials}
        chkall = {showallsite}
      />
    <div className="row mt-2 mb-4">
      <div className="col-lg-3 col-md-8  mb-2 ">
        
        <Select
          data={branchlist}
          // label="โรงชิพ"
          value={branchId}
          textProperty="name"
          valueProperty="_id"
          onChange={handleBranchChange}
        />
        
      </div>
      <div className="ms-4 mt-2">
      <Totalcar  list = {totallist} onClick = {handelClick}/>
      </div>
      </div>
      { showprogress && <ProgressBar bgcolor={"#FF0066"}  />}
      <Reporttable list={currentcar} header={headlist} handelClick = {handelDetailClick}  />
    </>
  );
};

export default Reportwms;
